import {Controller} from '@stubhub/react-store-provider';
import {get} from '@stubhub/rest-method';

const NAMESPACE = 'header';

const DEFAULT_CACHE_TTL = 900; // 15 mins

/* istanbul ignore next */
function loadSubCatNavContent() {
  return (dispatch, getState, {logger}) => {
    return get({
      host: process.env.REACT_APP_CMX_API_HOST,
      path: '/cms/content-content/homepage/components.json',
      proxy: process.env.REACT_APP_GENERAL_PROXY_SERVER,
      json: true,
      cache: true,
      cacheMaxAge: parseInt(process.env.REACT_APP_CACHE_TTL_CATALOG, 10) || DEFAULT_CACHE_TTL,
      logger,
    })
      .then((body = {}) => {
        if (body.subCatNav) {
          dispatch({type: 'SUBCATNAV_CONTENT_LOADED', subCatNav: body.subCatNav});
        }

        return '';
      })
      .catch((e) => {
        logger && logger.error(e);
      });
  };
}

function loadMultiLayeredMenu() {
  return (dispatch, getState, {logger}) => {
    const storeId = getState().gsConfig.shstoreId;

    return get({
      host: process.env.REACT_APP_CMX_API_HOST,
      path: `/cms/content-content/homepage/site-nav/${storeId}.json`,
      proxy: process.env.REACT_APP_GENERAL_PROXY_SERVER,
      json: true,
      cache: true,
      cacheMaxAge: parseInt(process.env.REACT_APP_CACHE_TTL_CATALOG, 10) || DEFAULT_CACHE_TTL,
      logger,
    })
      .then((body = {}) => {
        if (body.discovery) {
          dispatch({type: 'MULTILAYERNAV_CONTENT_LOADED', multiLayeredMenu: body});
        }

        return '';
      })
      .catch((e) => {
        logger && logger.error(e);
      });
  };
}

const selectedCurrencySelector = ({currencyExchange = {}}) => currencyExchange.selectedCurrency;

const controller = new Controller({
  namespace: NAMESPACE,
  mapStateToProps(state) {
    const viewportState = state.viewport || {};
    const subCategoriesContent = state[NAMESPACE] && state[NAMESPACE].subCatNav;

    return {
      screenSize: viewportState.screenSize,
      subCategoriesContent,
      selectedCurrency: selectedCurrencySelector(state),
    };
  },
  actionCreators: {
    showSearchBarModal,
    loadSubCatNavContent,
    loadMultiLayeredMenu,
  },
  reducers: ['SUBCATNAV_CONTENT_LOADED', 'MULTILAYERNAV_CONTENT_LOADED'],
});

/**
 * Callback function that Dispatches 'SEARCH_BAR_MODAL_SHOW' event to Show the Search Bar.
 *
 */
function showSearchBarModal() {
  return (dispatch) => {
    const isModalSearchActive = true;
    dispatch({type: 'SEARCH_BAR_MODAL_SHOW', isModalSearchActive});
  };
}

export default controller;
